import React, { useRef, useEffect, useState } from "react"
import { graphql, PageProps } from "gatsby"
// import Link from "gatsby-plugin-transition-link"
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll"
import Layout from "../components/_layout"
import SEO from "../components/seo"
import cn from "classnames"
import * as s from "./index.module.scss"
import reloadFontplus from "../utils/reloadFontplus"
import Image from "../components/image"
import ServiceIndex from "../components/service-index"
import CasestudySlider from "../components/casestudy-slider"
import NewsList from "../components/news-list"
import BigIconButton from "../components/button/big-icon"
import RoundButton from "../components/button/round"
import ToTopButton from "../components/button/to-top"
import KvMp4 from "../assets/video/kv.mp4"
import setObserver from "../utils/setObserver"

type DataProps = GatsbyTypes.IndexPageQuery

const IndexPage: React.FC<PageProps<DataProps>> = ({ data, location }) => {
  const [showTitle, setShowTitle] = useState(false)

  const [showKv, setShowKv] = useState(false)
  const [showFigure, setShowFigure] = useState(false)
  const [showImgMan, setShowImgMan] = useState(false)
  const [showImgWoman, setShowImgWoman] = useState(false)
  const [showStateLabel, setShowStateLabel] = useState(false)
  const [showStateTitle, setShowStateTitle] = useState(false)
  const [showStateText, setShowStateText] = useState(false)
  const [showTechCircle, setShowTechCircle] = useState(false)

  const targetKv = useRef<HTMLDivElement>(null)
  const targetFigure = useRef<HTMLDivElement>(null)
  const targetImgMan = useRef<HTMLDivElement>(null)
  const targetImgWoman = useRef<HTMLDivElement>(null)
  const targetStateLabel = useRef<HTMLDivElement>(null)
  const targetStateTitle = useRef<HTMLDivElement>(null)
  const targetStateText = useRef<HTMLDivElement>(null)
  const targetTechCircle = useRef<HTMLDivElement>(null)

  const scrollToTop = () => {
    scroll.scrollToTop({ duration: 1000, smooth: "easeInOutQuart" })
  }

  useEffect(() => {
    reloadFontplus()

    const observerKv = setObserver(
      targetKv.current,
      "-80% 0% 0% 0%",
      setShowKv,
      true
    )

    const observerFigure = setObserver(
      targetFigure.current,
      "0% 0% -5% 0%",
      setShowFigure
    )

    const observerImgMan = setObserver(
      targetImgMan.current,
      "0% 0% -5% 0%",
      setShowImgMan
    )

    const observerImgWoman = setObserver(
      targetImgWoman.current,
      "0% 0% -5% 0%",
      setShowImgWoman
    )

    const observerStateLabel = setObserver(
      targetStateLabel.current,
      "0% 0% -10% 0%",
      setShowStateLabel
    )

    const observerStateTitle = setObserver(
      targetStateTitle.current,
      "0% 0% -10% 0%",
      setShowStateTitle
    )

    const observerStateText = setObserver(
      targetStateText.current,
      "0% 0% -10% 0%",
      setShowStateText
    )

    const observerTechCircle = setObserver(
      targetTechCircle.current,
      "0% 0% -30% 0%",
      setShowTechCircle
    )

    playVideo()
    async function playVideo() {
      try {
        await targetKv.current.getElementsByTagName("video")[0].play()
      } catch (err) {
        // console.log(err)

        // Low Power Mode for iOS
        targetKv.current
          .getElementsByTagName("video")[0]
          .setAttribute("poster", "/assets/images/top/kv-poster.png")
      }
    }

    setTimeout(() => {
      setShowTitle(true)
    }, 100)

    return () => {
      observerKv.disconnect()
    }
  }, [])

  return (
    <Layout location={location}>
      <SEO title="学びを、もっと、新しく。" />
      <section className={s.kv} ref={targetKv}>
        <div className={cn(s.kv_bg, { [s.show]: showKv })}>
          <video playsInline loop preload="auto" muted>
            <source src={KvMp4} type="video/mp4" />
          </video>
        </div>

        <h1 className={cn(s.kv_title, { [s.show]: showTitle })}>
          <img
            src="/assets/svg/text-namabiwo.svg"
            alt="学びを、もっと、新しく。"
          />
        </h1>

        <ScrollLink
          to="statement"
          smooth="easeInOutQuart"
          duration={1200}
          className={cn(s.button_scroll, { [s.show]: showKv })}
        >
          <span className={s.line}></span>
          <span className={s.text}>Scroll</span>
        </ScrollLink>
      </section>

      <section className={s.state} id={"statement"}>
        <div className={cn(s.state_bg, { [s.show]: showStateLabel })}></div>
        <div className={s.state_inner}>
          <div
            className={cn(s.state_image1, { [s.show]: showImgMan })}
            ref={targetImgMan}
          >
            <div className={s.image}>
              <Image filename="top/statement-1.png" alt="" />
            </div>
          </div>
          <p
            className={cn(s.state_label, { [s.show]: showStateLabel })}
            ref={targetStateLabel}
          >
            Statement
          </p>

          <div className={s.state_body}>
            <h2
              className={cn(s.state_title, { [s.show]: showStateTitle })}
              ref={targetStateTitle}
            >
              <span>学びを、</span>
              <span>もっと、</span>
              <br />
              <span>新しく。</span>
            </h2>
            <div
              className={cn(s.state_text, { [s.show]: showStateText })}
              ref={targetStateText}
            >
              <p>
                あなたは、何が好きなんだろう。
                <br />
                あなたは、どんなことに心を動かされるんだろう。
                <br />
                あなたはこれから、どんな未来を生きていきたいんだろう。
              </p>
              <p>
                学ぶこと。
                <br />
                それは本来、他の誰かに強いられることではないと思います。
                <br />
                心がワクワクするままに、思い描いた未来をめざして。
                <br />
                自分から、夢中になって、知恵や知識を吸収し続ける。
                <br />
                そして、学びから得た力をもとに、どこまでも自分らしく、
                <br className={s.br_pc} />
                自由に生きていくこと。
                <br />
                それこそが、あるべき学びの姿なのだと思います。
              </p>
              <p>
                日本が、そして世界中が、
                <br className={s.br_pc} />
                自分らしく学ぶ人であふれる社会になってほしい。
                <br />
                そんな想いから私たちは、
                <br className={s.br_pc} />
                データと、テクノロジーと、人の力を融合した
                <br className={s.br_pc} />
                新たな学び体験を世の中に提案・提供し続けています。
              </p>
              <p>
                もっと自分らしく学ぼう。
                <br className={s.br_pc} />
                もっと自分らしく生きていこう。
              </p>
              <p>
                スタディサプリは、
                <br className={s.br_pc} />
                学ぶ人、学びを支える人に寄り添い、
                <br className={s.br_pc} />
                自己実現の最大化をサポートしていくサプリメントです。
              </p>
            </div>
          </div>

          <div
            className={cn(s.state_image2, { [s.show]: showImgWoman })}
            ref={targetImgWoman}
          >
            <div className={s.image}>
              <Image filename="top/statement-2.png" alt="" />
            </div>
          </div>
        </div>
      </section>

      <div className={s.boxSectionWrap}>
        <section className={cn(s.boxSection, s.method)}>
          <div className={s.boxSection_inner}>
            <div className={s.boxSection_contents}>
              <p className={s.method_label} aria-hidden="true">
                Method
              </p>

              <div className={s.boxSection_image}>
                <div
                  className={cn(s.image, { [s.show]: showFigure })}
                  ref={targetFigure}
                >
                  <div className={s.imageInner}>
                    <Image filename="method-mob.png" alt="" />
                    <Image filename="method-pc.png" alt="" />
                  </div>
                </div>
              </div>

              <div className={s.boxSection_text}>
                <h2 className={s.method_title}>
                  <span aria-hidden="true">Method</span>
                  <span aria-hidden="false">Method</span>
                </h2>
                <div className={s.boxSection_body}>
                  <p className={s.lead}>
                    スタサプメソッドを通じて、
                    基礎から応用、そして非認知能力の育成まで、トータルでサポートします。
                  </p>
                  <p className={s.body}>
                    スタディサプリは、独自のノウハウを体系化した「スタサプメソッド」のもと、一人ひとり異なる学びの理解度に合わせて、最適化された学びを提供します。40,000本を超える講義動画や演習教材、そして到達度テストにより、質の高いインプットとアウトプットを繰り返し、一人ひとりの真に「わかる」を実現。さらに、これからの時代により一層必要とされる非認知能力（EQ）の育成までもトータルでサポートしています。
                  </p>
                  <BigIconButton label="スタサプメソッドとは" href="/method/" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className={cn(s.boxSection, s.technology)}>
          <div className={s.boxSection_inner}>
            <div className={s.boxSection_contents}>
              <p className={s.technology_label} aria-hidden="true">
                Technology
              </p>

              <div className={s.boxSection_image}>
                <div
                  className={cn(s.image_wrap, { [s.show]: showTechCircle })}
                  ref={targetTechCircle}
                >
                  <div className={s.image}>
                    <Image filename="top/technology.jpg" alt="" />
                  </div>
                </div>
              </div>

              <div className={s.boxSection_text}>
                <h2 className={s.technology_title}>
                  <span aria-hidden="true">Technology</span>
                  <span aria-hidden="false">Technology</span>
                </h2>

                <div className={s.boxSection_body}>
                  <p className={s.lead}>
                    データ×テクノロジー×人。
                    <br />
                    3つの力を融合して、
                    <br />
                    世界中の人に新たな学び体験を。
                  </p>
                  <p className={s.body}>
                    これまで蓄積してきた膨大な学習ビッグデータを最大限に活用し、学ぶ側と学びを支える側の双方が本当に必要とする多様な機能を開発。誰もが使いやすく、安心して楽しく学び続けられるように、最先端のテクノロジーを駆使して最適なカタチで提供しています。
                  </p>
                  <BigIconButton label="私たちについて" href="/about/" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className={s.service}>
        <div className={s.service_header}>
          <h2 className={s.service_title}>
            <span aria-hidden="true">Service</span>
            <span aria-hidden="false">Service</span>
          </h2>
          <p className={s.service_lead}>
            スタディサプリは、
            <br />
            学びに関わるすべての人を
            <br />
            支援します。
          </p>
        </div>
        <ServiceIndex />
      </section>

      <section className={s.casestudy}>
        <div className={s.section_header}>
          <h2 className={s.section_title}>
            <span className={s.en}>Case Study</span>
            <span className={s.ja}>スタディサプリの導入事例</span>
          </h2>
          <div className={s.more}>
            <RoundButton label="一覧を見る" href="/casestudy/" />
          </div>
        </div>

        <CasestudySlider
          posts={data.casestudy.nodes as GatsbyTypes.ContentfulCasestudy[]}
        />
      </section>

      <section>
        <div className={s.section_header}>
          <h2 className={s.section_title}>
            <span className={s.en}>News</span>
            <span className={s.ja}>ニュース</span>
          </h2>
          <div className={s.more}>
            <RoundButton label="一覧を見る" href="/news/" />
          </div>
        </div>

        <NewsList posts={data.news.nodes as GatsbyTypes.ContentfulNews[]} />
      </section>

      <ToTopButton />

      {/* <pre>{JSON.stringify(data, null, 4)}</pre> */}
    </Layout>
  )
}

export default IndexPage

export const query = graphql`query IndexPage {
  site {
    buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    siteMetadata {
      title
    }
  }
  casestudy: allContentfulCasestudy(limit: 5, sort: {publishedAt: DESC}) {
    nodes {
      id
      title
      slug
      category {
        title
        slug
      }
      tag {
        title
        slug
      }
      targetGroup
      listImage {
        gatsbyImageData(width: 1080, layout: CONSTRAINED)
        file {
          url
        }
      }
    }
  }
  news: allContentfulNews(limit: 3, sort: {publishedAt: DESC}) {
    nodes {
      id
      slug
      title
      publishedAt(formatString: "YYYY-MM-DD")
      image {
        gatsbyImageData(width: 1080, layout: CONSTRAINED)
        file {
          url
        }
      }
    }
  }
}`
